export const GET_ATAC_FILE = 'GET_ATAC_FILE'
export const GET_ATAC_FILE_SUCCESS = 'GET_ATAC_FILE_SUCCESS'
export const GET_ATAC_FILE_ERROR = 'GET_ATAC_FILE_ERROR'